import React, { useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import momentPlugin from "@fullcalendar/moment";

const FRONTEND_URL = process.env.GATSBY_SITE_URL;

function CalendarGrid({ items, mode }) {
	if (!items) return <></>;
	const theme = useTheme();
	let color = theme.palette.primary.main;
	let attrs = {
		target: "_blank",
	};
	return (
		<>
			{mode ? (
				<Box
					component="div"
					{...attrs}
					className="calendargrid"
					sx={{
						width: "90%",
						height: "100%",
						paddingLeft: "24px",
						paddingRight: "1%",
						"& .fc-liquid-hack": {
							height: "100%",
							width: "90%",
							paddingLeft: "24px",
							paddingRight: "1%",
						},
						"& a": {
							target: "_blank",
						},
						"& .entities-list-calendar": {
							height: "100%",
							width: "90%",
							paddingLeft: "24px",
						},
						"@media (max-width: 600px)": {
							width: "90%",
							height: "100%",
							paddingLeft: "12px",
							"& .fc-liquid-hack": {
								height: "100%",
								width: "90%",
								marginLeft: "1%",
								paddingLeft: "12px",
								paddingRight: "1%",
							},
						},
					}}
				>
					<FullCalendar
						classNames={["calendargrid"]}
						plugins={[dayGridPlugin, momentPlugin]}
						timeZone="America/Los_Angeles"
						selectable={true}
						aspectRatio={1}
						updateSize={true}
						initialView="dayGridMonth"
						weekends={true}
						displayEventTime={false}
						displayEventEnd={false}
						eventBackgroundColor={color}
						eventClick={function (info) {
							info.jsEvent.preventDefault(); // don't let the browser navigate
							if (info.event.url && typeof window !== "undefined") {
								window.open(info.event.url);
							}
						}}
						expandRows={true}
						slotEventOverlap={false}
						events={items
							.filter((i) => !!i.dates)
							.map((i) => ({
								title: i.title,
								start: i.dates[0],
								end: i.dates[1] ? i.dates[1] : i.dates[0],
								startStr: i.dates[0],
								endStr: i.dates[1] ? i.dates[1] : i.dates[0],
								url: `${FRONTEND_URL}${i.slug}`,
								display: "block",
								description: i.summary,
								allDay: false,
							}))}
					/>
				</Box>
			) : (
				<></>
			)}
		</>
	);
}

export default CalendarGrid;
